module.exports = __webpack_public_path__ + "assets/citie.6a09ad3a.svg";